(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/bingo-card-desktop.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/bingo-card-desktop.js');
"use strict";

const _React = React,
  useMemo = _React.useMemo;
const _svs$bingo_react$comp = svs.bingo_react.components.bingoCard,
  CardImage = _svs$bingo_react$comp.CardImage,
  InfoItem = _svs$bingo_react$comp.InfoItem,
  HostFlerp = _svs$bingo_react$comp.HostFlerp,
  JackpotRibbon = _svs$bingo_react$comp.JackpotRibbon;
const Badge = svs.ui.ReactBadge;
const startBingoGame = svs.bingo_react.components.startBingoGame;
const _svs$bingo_react$comp2 = svs.bingo_react.components.common,
  getBingoCardAriaLabel = _svs$bingo_react$comp2.accessibilityHelpers.getBingoCardAriaLabel,
  PlayMode = _svs$bingo_react$comp2.constants.PlayMode;
const useStartTimer = svs.bingo_react.components.useStartTimer;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;
const BingoCardDesktop = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    promoPosition = _ref.promoPosition,
    _ref$gameData = _ref.gameData,
    gameId = _ref$gameData.id,
    badgeText = _ref$gameData.badgeText,
    host = _ref$gameData.host,
    jackpotAmount = _ref$gameData.jackpotAmount,
    startTime = _ref$gameData.startTime,
    subTitle = _ref$gameData.subTitle,
    price = _ref$gameData.price,
    players = _ref$gameData.players,
    title = _ref$gameData.title,
    status = _ref$gameData.status,
    playMode = _ref$gameData.playMode,
    lastWinTimestamp = _ref.lastWinTimestamp;
  const classList = ['bingo-card-desktop'];
  classList.push(className);
  const isMultiPlayer = useMemo(() => playMode === PlayMode.Multi, [playMode]);
  const timer = useStartTimer(startTime, status);
  const ariaLabel = useMemo(() => getBingoCardAriaLabel({
    title,
    bingoCardPrice: price,
    players: isMultiPlayer ? players : null,
    addTimer: isMultiPlayer,
    timer,
    status,
    jackpotAmount
  }), [title, price, players, isMultiPlayer, timer, status, jackpotAmount]);
  return React.createElement(Card, {
    "aria-label": ariaLabel,
    className: classList.join(' '),
    Component: "a",
    "data-area-name": promoPosition,
    "data-impression": "true",
    "data-impression-tracking": "bingo-card-".concat(promoPosition),
    onClick: () => startBingoGame(gameId, promoPosition),
    onKeyDown: e => e.key === 'Enter' && startBingoGame(gameId),
    role: "button",
    tabIndex: 0
  }, React.createElement(CardBody, {
    className: "bingo-card-desktop__body"
  }, host && React.createElement(HostFlerp, {
    hostName: host.name
  }), jackpotAmount && React.createElement(JackpotRibbon, {
    jackpotAmount: jackpotAmount
  }), React.createElement("div", {
    className: "bingo-card-desktop__image-container"
  }, React.createElement(CardImage, {
    gameId: gameId,
    lastWinTimestamp: lastWinTimestamp,
    showTimer: playMode !== 'SINGLEUSER',
    startTime: startTime,
    status: status
  })), React.createElement("div", {
    className: "bingo-card-desktop-info"
  }, React.createElement("div", {
    className: "bingo-card-desktop-info-title"
  }, React.createElement("h3", {
    className: "bingo-card-desktop-info-title__title"
  }, title, badgeText && React.createElement(Badge, {
    branding: "red",
    className: "bingo-card-desktop-info-title__badge"
  }, badgeText)), React.createElement("h4", {
    className: "bingo-card-desktop-info-title__subtitle"
  }, subTitle)), React.createElement("div", {
    className: "bingo-card-desktop-info__info"
  }, React.createElement(InfoItem, {
    bold: true,
    icon: "".concat(playMode === 'SINGLEUSER' ? 'user' : 'players'),
    label: "".concat(playMode === 'SINGLEUSER' ? '' : "".concat(players, " st"))
  }), React.createElement(InfoItem, {
    bold: true,
    icon: "money",
    label: "".concat(price, " kr")
  })))));
};
setGlobal('svs.bingo_react.components.bingoCard.BingoCardDesktop', BingoCardDesktop);

 })(window);